"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.handleNotificationTimeout = handleNotificationTimeout;
exports.saga = saga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var notificationsActions = _interopRequireWildcard(require("./userInterfaceNotifications.actions"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked = /*#__PURE__*/_regenerator["default"].mark(handleNotificationTimeout),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(saga);

var generateRandomIdFunction = function generateRandomIdFunction() {
  return Math.round(Math.random() * 9999999999999999);
};

function handleNotificationTimeout(payload) {
  var notificationId, _payload$timeout, timeout, _payload$message, message, _payload$closable, closable, _payload$icon, icon, _payload$action, action;

  return _regenerator["default"].wrap(function handleNotificationTimeout$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          notificationId = generateRandomIdFunction().toString();
          _payload$timeout = payload.timeout, timeout = _payload$timeout === void 0 ? 7000 : _payload$timeout, _payload$message = payload.message, message = _payload$message === void 0 ? "" : _payload$message, _payload$closable = payload.closable, closable = _payload$closable === void 0 ? false : _payload$closable, _payload$icon = payload.icon, icon = _payload$icon === void 0 ? null : _payload$icon, _payload$action = payload.action, action = _payload$action === void 0 ? null : _payload$action;
          _context.prev = 2;
          _context.next = 5;
          return (0, _effects.put)(notificationsActions.addNotificationAfter({
            timeout: timeout,
            message: message,
            closable: closable,
            icon: icon,
            action: action,
            id: notificationId,
            timeStamp: Date.now()
          }));

        case 5:
          if (!timeout) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return (0, _effects.delay)(timeout);

        case 8:
          _context.next = 10;
          return (0, _effects.put)(notificationsActions.removeNotification({
            id: notificationId
          }));

        case 10:
          _context.next = 15;
          break;

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          console.log(_context.t0);

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2, 12]]);
}

function saga() {
  return _regenerator["default"].wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(notificationsActions.types.ADD_NOTIFICATION, function (_ref) {
            var payload = _ref.payload;
            return handleNotificationTimeout(payload);
          });

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}